import React from 'react';
import styles from './OrderTable.module.scss';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import { tooltipStyle, tooltip, tooltipClick } from '@/components/TableCell';
import { XPagination } from '@/components/xqxc_ui';

class OrderTable extends React.Component {
    state = {
        selectedRowKeys: [],
    }
    _takeColumns = () => ([
        {
            title: '消息主题',
            dataIndex: 'messageTitle',
            key: 'messageTitle',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: (text, item) => tooltipClick(text, () => {
                this.props.tableAction(item.id, 'info', item);
            })
        },
        {
            title: '推送终端',
            dataIndex: 'systemTypeValue',
            key: 'systemTypeValue',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '推送时间',
            dataIndex: 'pushTime',
            key: 'pushTime',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '消息状态',
            dataIndex: 'messageStateValue',
            key: 'messageStateValue',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'key',
            key: 'action',
            align: 'center',
            width: '20%',
            render: (text, item) => this._renderActionCell(item.id, item.messageState)
        }
    ]);

    _takeDataSource = (dataList) => {
        if (dataList) {
            return dataList;
        } else {
            return [];
        }
    }

    _renderActionCell = (key, status) => {
        // 0 待发送 1 已发送 2 取消发送
        const { tableAction } = this.props;
        return (
            <div className={styles.action}>
                {/* {(status && (status.code === 'SENT' || status.code === 'CANCEL')) && <div className={styles.item} onClick={() => tableAction(key, 'info')}>查看详情</div>} */}
                {/* {status.code === 'UNSENT' && <div className={styles.item} onClick={() => tableAction(key, 'send')}>立即发送</div>} */}
                { status === 'UNSENT' && <div className={styles.item} onClick={() => tableAction(key, 'edit')}>编辑</div>}
                {status === 'CANCEL' ? <div className={styles.item} onClick={() => tableAction(key, 'open')}>开启</div> :
                    <div className={styles.item} onClick={() => tableAction(key, 'close')}>关闭</div>
                }
                <div className={styles.item} onClick={() => tableAction(key, 'delete')}>删除</div>
            </div>
        );
    }

    // 表格复选输入
    _rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            this.setState({
                selectedRowKeys,
            });
            console.log(selectedRows);
        }
    };
    // 清空表格复选框
    _cleanAllSelected = () => {
        this.setState({ selectedRowKeys: [] });
    };
    render() {
        const { selectedRowKeys } = this.state;
        const { paginationChange } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        this._rowSelection.selectedRowKeys = selectedRowKeys;
        return (
            <div className={styles.tableContainer}>
                {/* <XTableSelectionCount selectedNum={selectedRowKeys.length} onClean={this._cleanAllSelected} /> */}
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    // rowSelection={this._rowSelection}
                    rowKey={(record, index) => index}
                    columns={this._takeColumns()}
                    dataSource={this._takeDataSource(dataList)}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

OrderTable.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};

export default OrderTable;
